import { useHistory } from 'react-router-dom';
import { Fade, Link, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';

import AuthLayout from 'layouts/auth-layout';

const useStyles = makeStyles(() => ({
  logo: { display: 'flex', margin: 'auto', marginTop: '50px', marginBottom: '25px' },
}));

const NotFoundPage = () => {
  const classes = useStyles();
  const history = useHistory();

  return (
    <AuthLayout>
      <Fade in={true}>
        <div>
          <div style={{ textAlign: 'center' }}>
            <img src={'/logo-light-stacked.svg'} alt="Trustate Logo" className={classes.logo} />
            <Typography variant="h5" style={{ marginTop: '50px', marginBottom: '10px' }}>
              Page not found
            </Typography>
            <Typography style={{ marginBottom: '25px' }}>
              The page you're looking could not be found.
            </Typography>
            <Typography style={{ textDecoration: 'underline', cursor: 'pointer' }}>
              <Link onClick={() => history.push('/')}>Go back home</Link>
            </Typography>
          </div>
        </div>
      </Fade>
    </AuthLayout>
  );
};

export default NotFoundPage;
